export const fcp = {
    value: 0,
};
